import { createContext } from '@chakra-ui/react-utils';

const [TableProvider, useTableContext] = createContext({
  name: 'TableContext',
  errorMessage:
    'useTableContext: `context` is undefined. Seems you used a table sub-component outside of a table wrapping box.',
});

export { TableProvider, useTableContext };
